import Logo from './logo.js';
import LogoLanding from './logo-landing.js';
import LogoShort from './logo-short.js';
import LogoMobile from './logo-mobile.js';
import LogoSingleColor from './logo-single-color.js';
import '../styles.js';
import AppLogo from './app-logo.js';

const LOGO_MOBILE_WIDTH = 126; // svg logo width for mobile header

export default {
	Logo,
	LogoLanding,
	LogoShort,
	LogoMobile,
	LOGO_MOBILE_WIDTH,
	AppLogo,
	LogoSingleColor
};
